"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlManageStudentOverdueDefaultArgs = exports.IlManageStudentOverdueDefault = exports.ButtonManageOverduePopup = void 0;
var react_1 = __importDefault(require("react"));
var date_fns_1 = require("date-fns");
var enums_1 = require("../../shared/enums");
var assignment_state_enum_1 = require("../../shared/enums/assignment-state.enum");
var assignment_type_enum_1 = require("../../shared/enums/assignment-type.enum");
var get_component_1 = require("../../shared/helpers/get-component");
var il_manage_student_overdue_1 = require("./il-manage-student-overdue");
var material_1 = require("@mui/material");
var il_button_common_1 = require("../il-button/il-button.common");
var system_1 = require("@mui/system");
var manage_overdue_drawer_1 = require("./manage-overdue.drawer");
var manage_overdue_popup_1 = require("./manage-overdue.popup");
var today = new Date();
// Math Course
var algebraLesson = {
    subject: enums_1.SubjectEnum.MATH,
    assignmentType: assignment_type_enum_1.AssignmentTypeEnum.LESSON,
    assignmentTitle: 'Introduction to Real Numbers',
    assignmentState: assignment_state_enum_1.AssignmentStateEnum.ACTIVE,
    courseTitle: 'Algebra I',
    unitTitle: 'Unit 2: Real Numbers and Their Operations',
    dateToday: today,
    dueDate: today,
    sequence: 3,
};
var algebraQuiz = __assign(__assign({}, algebraLesson), { assignmentTitle: 'Real Numbers Quiz', assignmentType: assignment_type_enum_1.AssignmentTypeEnum.QUIZ, sequence: 4 });
var geographyLesson = {
    subject: enums_1.SubjectEnum.GEOGRAPHY,
    assignmentType: assignment_type_enum_1.AssignmentTypeEnum.LESSON,
    assignmentTitle: 'Latitude and Longitude',
    assignmentState: assignment_state_enum_1.AssignmentStateEnum.OVERDUE,
    courseTitle: 'World Geography',
    unitTitle: 'Unit 2: Real Numbers and Their Operations',
    dateToday: today,
    dueDate: (0, date_fns_1.subDays)(today, 1),
    sequence: 3,
};
var IlManageStudentOverdueDefaultArgs = {
    title: 'Manage Overdue Work',
    coursesAssignment: [
        {
            courseId: 'aaa-123-das',
            courseName: 'Mathematics',
            assignmentProps: [algebraLesson, algebraQuiz],
        },
        {
            courseId: 'aaa-123-345',
            courseName: 'History & Geography',
            assignmentProps: [geographyLesson],
        },
    ],
    studentProps: {
        name: 'DeeDee',
        avatar: 'RED',
        assignmentsText: 'Overdue',
        assignmentsNumber: 3,
    },
};
exports.IlManageStudentOverdueDefaultArgs = IlManageStudentOverdueDefaultArgs;
var IlManageStudentOverdueDefault = (0, get_component_1.getComponent)(il_manage_student_overdue_1.ILManageStudentOverdue, IlManageStudentOverdueDefaultArgs);
exports.IlManageStudentOverdueDefault = IlManageStudentOverdueDefault;
function ButtonManageOverduePopup(_a) {
    var open = _a.open, onClose = _a.onClose, props = __rest(_a, ["open", "onClose"]);
    var _b = react_1.default.useState(open), openDialog = _b[0], setOpen = _b[1];
    var ref = react_1.default.createRef();
    react_1.default.useEffect(function () {
        var _a;
        if (openDialog) {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }, [ref, openDialog]);
    var theme = (0, system_1.useTheme)();
    var showUpMd = (0, material_1.useMediaQuery)(theme.breakpoints.up('md'));
    function handleClose() {
        onClose && onClose();
        setOpen(false);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(il_button_common_1.ManageOverdueButton, { onClick: function () { return setOpen(true); } }),
        openDialog && (react_1.default.createElement(react_1.default.Fragment, null,
            showUpMd && react_1.default.createElement(manage_overdue_popup_1.ManageOverduePopup, __assign({}, props, { open: openDialog, onClose: handleClose })),
            !showUpMd && react_1.default.createElement(manage_overdue_drawer_1.ManageOverdueDrawer, __assign({ ref: ref, handleClose: handleClose }, props))))));
}
exports.ButtonManageOverduePopup = ButtonManageOverduePopup;
